import { Link, useParams } from 'react-router-dom';
import { useSeo } from '@/hooks/useSeo';
import WorkCard from '@/components/WorkCard';
import { categories, works } from '@/mocks/doujin';

export default function CategoryPage() {
  const { slug = '' } = useParams();
  const category = categories.find((c) => c.slug === slug) || categories[0];
  const list = works.filter((w) => w.category === category.slug);

  useSeo({
    title: `${category.name} - 今日同人库分类浏览·同人汉化连载`,
    description: `${category.description}。浏览今日同人库「${category.name}」分类下的同人作品，查看最新汉化与连载进度，追更不再错过。`,
    keywords: `今日同人库,${category.name},同人汉化,同人连载`,
  });

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: `${category.name}分类`,
    description: category.description,
    inLanguage: 'zh-CN',
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
      <div className="bg-secondary-50/70 px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-7xl mx-auto">
          <nav className="text-sm text-foreground-500 mb-3" aria-label="面包屑">
            <Link to="/" className="hover:text-primary-700">首页</Link>
            <span className="mx-2">/</span>
            <span className="text-foreground-700">分类</span>
            <span className="mx-2">/</span>
            <span className="text-foreground-700">{category.name}</span>
          </nav>
          <div className="flex items-center gap-4">
            <span className="w-14 h-14 flex items-center justify-center rounded-xl bg-secondary-500 text-background-50 text-2xl shrink-0">
              <i className={category.icon}></i>
            </span>
            <div>
              <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">{category.name}作品</h1>
              <p className="mt-2 text-foreground-500 text-sm md:text-base max-w-2xl">{category.description}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="px-4 md:px-6 max-w-7xl mx-auto py-10">
        <div className="flex items-center justify-between mb-6">
          <p className="text-sm text-foreground-500">
            「{category.name}」分类下共 <span className="font-semibold text-primary-700">{list.length}</span> 部作品
          </p>
          <Link to="/updates" className="inline-flex items-center gap-1 text-primary-700 text-sm hover:text-primary-600 whitespace-nowrap">
            查看全部更新 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        {list.length > 0 ? (
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5">
            {list.map((w) => (
              <WorkCard key={w.slug} work={w} />
            ))}
          </div>
        ) : (
          <div className="text-center py-20">
            <i className="ri-book-3-line text-5xl text-background-300"></i>
            <p className="mt-4 text-foreground-500">该分类作品整理中，敬请期待</p>
          </div>
        )}
      </div>
    </>
  );
}